import { render, staticRenderFns } from "./WorkoutItem.vue?vue&type=template&id=5a65aa9d"
import script from "./WorkoutItem.vue?vue&type=script&lang=js"
export * from "./WorkoutItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports